import cookies from "vue-cookies"
const ProjFn = {
    getToken: () => {
        return (cookies as any).get("token")
    },
    setToken: (token) => {
        (cookies as any).set("token", token, 60 * 60 * 24)
    },
    removeToken: () => {
        (cookies as any).remove("token")
    },
    getShowNav: () => {
        return (cookies as any).get("showNav")
    },
    setShowNav: (token) => {
        (cookies as any).set("showNav", token, 60 * 60 * 24)
    },
    getIsios: () => {
        return (cookies as any).get("isIos")
    },
    setIsios: (token) => {
        (cookies as any).set("isIos", token, 60 * 60 * 24)
    },
    getVersion: () => {
        return (cookies as any).get("version")
    },
    setVersion: (token) => {
        (cookies as any).set("version", token, 60 * 60 * 24)
    },
    getDeviceId: () => {
        return (cookies as any).get("deviceId")
    },
    setDeviceId: (deviceId) => {
        (cookies as any).set("deviceId", deviceId, 60 * 60 * 24)
    },
    removeDeviceId: () => {
        (cookies as any).remove("deviceId")
    },
}

export default ProjFn;
